export default __webpack_public_path__ + "static/media/1K.b414c1b1.png";